import axios from "axios";
import Vue from "vue";
import i18n from '@/i18n/index';
const lang = i18n.locale;
const successCode = [200, 0, 103];
const codeForValue = {
  101: 'orderNotExistText',
  102: 'orderInvalidText',
  104: 'orderInvalidText',
};
const config = require("../../config");
const baseURL = config[process.env.NODE_ENV].baseUrl;
const service = axios.create({
  baseURL,
  timeout: 3000,
  headers: {
    'Content-Type': 'application/json',  // 默认 Content-Type 为 json
    'Accept-Language': localStorage.getItem('lang')
  }
});

service.interceptors.request.use(
  (config) => {
    config.headers['Accept-Language'] = localStorage.getItem('lang')
    if (config.url.includes('upload')) {
      config.headers['Content-Type'] = 'multipart/form-data'
      console.log(config, 'config')
    }
    // if(config)
    return config;
  },
  (error) => {
    Vue.prototype.$toast.fail(i18n.t('networkErrorText'));
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (res) => {
    if (res.status !== 200) {
      Vue.prototype.$toast.fail(i18n.t('networkErrorText'));
      return Promise.reject(res);
    } else if (res.status === 200 && !successCode.includes(res.data.code)) {
      Vue.prototype.$toast.fail(i18n.t('orderErrorText'));
      return Promise.reject(res);
    } else {
      return res.data;
    }
  },
  (error) => {
    Vue.prototype.$toast.fail(i18n.t('networkErrorText'));
    return Promise.reject(error);
  }
);

export default service;
